import React, { ReactNode } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import MedicationIcon from '@mui/icons-material/Medication';

interface BaseNav {
  text: string;
  icon?: ReactNode;
  verifiedOnly?: boolean;
}

export interface LeafNav extends BaseNav {
  path: string;
}

export interface ParentNav extends BaseNav {
  parentPath: string;
  childNavs: NavItemData[];
}

export type NavItemData = LeafNav | ParentNav;

export const navItems: NavItemData[] = [
  { text: 'patient-app.nav.home', path: '/', icon: <DashboardIcon /> },
  // {
  //   text: 'patient-app.nav.questionnaire',
  //   path: '/questionnaire',
  //   icon: <QuestionAnswerIcon />,
  //   verifiedOnly: true
  // },
  {
    text: 'patient-app.nav.myData',
    icon: <DataUsageIcon />,
    parentPath: '/data',
    verifiedOnly: true,
    childNavs: [
      {
        text: 'patient-app.nav.myData.analysis',
        path: '/analysis',
        icon: <AnalyticsIcon />
      },
      {
        text: 'patient-app.nav.myData.documents',
        path: '/documents',
        icon: <PermMediaIcon />
      },
      {
        text: 'patient-app.nav.myData.prescriptions',
        path: '/prescriptions',
        icon: <MedicationIcon />
      }
    ]
  },
  {
    text: 'patient-app.nav.profile',
    path: '/profile',
    icon: <ManageAccountsIcon />
  }
];

export const isParentNav = (nav: NavItemData): nav is ParentNav =>
  !!nav && 'childNavs' in nav;
